import { FileTypeEnum } from 'kuaidong-model'
import VueRouter, { RouteConfig } from 'vue-router'
import { BrowserUtil, RouterUtil, WeappUtil } from 'kuaidong-lib'

const Index = () => import('../activity/common-share-page/index.vue')
const Notice = () => import('../activity/common-share-page/Notice.vue')
const Poster = () => import('../activity/common-share-page/Poster.vue')

export const indexRoute: RouteConfig = {
  path: '/common-share',
  name: 'common_share',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '选择分享形式',
  },
}

export const noticeRoute: RouteConfig = {
  path: '/common-share-notice',
  name: 'common_share_notice',
  component: Notice,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '通知单',
  },
}
export const posterRoute: RouteConfig = {
  path: '/common-share-poster',
  name: 'common_share_poster',
  component: Poster,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '选择海报样式',
  },
}

// export const contestUploadRoute: RouteConfig = {
//   path: '/homework-contest-upload',
//   name: 'homework_contest_upload',
//   component: ContestUpload,
//   props: (route) => ({ ...route.query, ...route.params }),
//   meta: {
//     title: '上传参赛',
//   },
// }

// export const myContestRoute: RouteConfig = {
//   path: '/homework-contest-my-info',
//   name: 'homework_contest_my_info',
//   component: MyHomework,
//   props: (route) => ({ ...route.query, ...route.params }),
//   meta: {
//     title: '我的参赛作品',
//   },
// }

export default [indexRoute, noticeRoute, posterRoute]

export function navigateToSharePageHome(router: VueRouter) {
  router.push({ name: indexRoute.name })
}

export function navigateToSharePageNotice(router: VueRouter) {
  router.push({ name: noticeRoute.name })
}

// export function navigateToContestUpload(router: VueRouter) {
//   router.push({ name: contestUploadRoute.name })
// }

// export function navigateToMyContestInfo(router: VueRouter) {
//   router.push({ name: myContestRoute.name })
// }

// export function navigateToNameList(router: VueRouter) {
//   router.push({ name: nameListRoute.name })
// }
